import { BackToTownButton } from '../../components/BackToTownButton';

export interface IndexProps {
  message?: string;
}

export const Index = ({ message = 'タイピングがうまくひらけなかったみたい...' }: IndexProps) => {
  return (
    <div className="relative w-full h-screen bg-[#2570aa]">
      <div className="relative w-full h-full flex flex-col justify-center items-center gap-[10%] select-none">
        <img className="w-[35%]" src="/digitane_logo.webp" alt="タイトル" />
        <div className="text-3xl text-white text-center">
          <p>{message}</p>
          <p>じかんをおいてもういちどためしてみてね。</p>
        </div>
        <BackToTownButton buttonType="simple" />
      </div>
    </div>
  );
};
